<script setup>
	import { computed } from 'vue';
	import { DsIconButton } from '@coloplast/design-system';

	const props = defineProps({
		subNavigationItem: {
			type: Object,
			default: () => {},
		},
	});

	const formattedDescription = computed(() => {
		let div = document.createElement('div');
		div.innerHTML = props.subNavigationItem.Description;
		return div.textContent || div.innerText || '';
	});
</script>

<template>
	<li class="c-sub-navigation__item">
		<a
			class="c-sub-navigation__item-link"
			:href="subNavigationItem.Url"
		>
			<p
				v-if="subNavigationItem.Headline"
				class="c-sub-navigation__item-headline"
				v-text="subNavigationItem.Headline"
			></p>
			<p
				v-if="subNavigationItem.Description"
				class="c-sub-navigation__item-description"
			>
				{{ formattedDescription }}
			</p>
			<div
				v-if="subNavigationItem.Url"
				class="c-sub-navigation__item-button"
			>
				<ds-icon-button
					aria-label="Navigate forward"
					icon-name="navigate-forward"
					variant="tertiary"
					size="sm"
				/>
			</div>
		</a>
	</li>
</template>
